/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Faq_4_AInputs */

const en_serve_faq_4_a = /** @type {(inputs: Serve_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. While your computer is connected, "Try it on your phone" opens the app running on your computer through a secure Bystep link.`)
};

const id_serve_faq_4_a = /** @type {(inputs: Serve_Faq_4_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa. Selama komputermu tersambung, "Coba dulu di HP-mu" membuka aplikasi yang berjalan di komputermu lewat tautan aman dari Bystep.`)
};

/**
* | output |
* | --- |
* | "Yes. While your computer is connected, \"Try it on your phone\" opens the app running on your computer through a secure Bystep link." |
*
* @param {Serve_Faq_4_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_faq_4_a = /** @type {((inputs?: Serve_Faq_4_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Faq_4_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_faq_4_a(inputs)
	return en_serve_faq_4_a(inputs)
});